
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/batches",
      function () {
        return require("private-next-pages/batches/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/batches"])
      });
    }
  